import { useQuery } from 'react-query';
import request from '../helpers/request';

const getRequestCreationMethods = async () => {
  const res = await request.get(
    '/Request/creation_methods',
    {},
    'Не удалось загрузить возможные способы создания',
    []
  );
  return res;
};

const useRequestCreationMethods = (options) => {
  return useQuery('creationMethods', getRequestCreationMethods, options);
};

export default useRequestCreationMethods;
